<template>
  <div v-show="active === ruleForm.status">
    <el-dialog title="Irroba" :visible.sync="dialog">
      <el-form :model="ruleForm">
        <el-form-item label="Nome">
          <el-input disabled v-model="ruleForm.configuration.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Usuário">
              <el-input disabled v-model="ruleForm.configuration.user" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ID Conta">
              <el-input disabled v-model="ruleForm.configuration.id" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Senha">
          <el-input disabled v-model="ruleForm.configuration.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Código SEDEX">
              <el-input disabled v-model="ruleForm.configuration.sedex" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Código PAC">
              <el-input disabled v-model="ruleForm.configuration.pac" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!--el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button-->
        <el-button @click="dialog = false">OK</el-button>
        <!--el-button type="primary" @click="save()">Salvar</el-button-->
      </span>
    </el-dialog>
    <IntegrationCard image="/img/integration/logo-irroba.svg" title="Irroba" :status="ruleForm.status"
      :updatedAt="ruleForm.updatedAt" :options="ruleForm.options" :id="ruleForm.id" @configure="dialog = true" />

  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationCard from "../components/IntegrationCard.vue";

export default {
  name: "Integration",
  props: ["customer", "active"],
  methods: {
    setConfig(config) {
      const vm = this;
      vm.ruleForm.configuration.user = config.configuration["txt-chave"];
      vm.ruleForm.configuration.name = config.configuration["txt-name"];
      vm.ruleForm.configuration.pac = config.configuration["txt-pac"];
      vm.ruleForm.configuration.sedex = config.configuration["txt-sedex"];
      vm.ruleForm.configuration.id = config.configuration["base-url"];
      vm.ruleForm.configuration.password = config.configuration["txt-token"];
      vm.ruleForm.id = config.id;
      vm.ruleForm.status = config.status;
      vm.ruleForm.updatedAt = config.updatedAt;
    },
    reset() {
      const vm = this;
      vm.ruleForm = {
        status: false,
        options: [],
        configuration: {
          user: "",
          password: "",
        },
        updatedAt: "Sem registros"
      };
    },
    save() {
      var vm = this;
      const loading = vm.$loading(vm.$options.loading);
      if (vm.ruleForm.id) {
        IntegrationService.update(vm.ruleForm.id, { type: "2", configuration: vm.toutbox.configuration, customer: vm.customer })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog.toutbox = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
      else {
        IntegrationService.add({ type: "2", configuration: vm.toutbox.configuration, customer: vm.customer })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog.toutbox = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    logs: function () {
      const vm = this;
      this.$router.push({
        name: "integration.logs",
        params: { id: vm.ruleForm.id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-integracao", { id: "Bling" }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.delete(vm.ruleForm.id)
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        configuration: {
          name: "",
          key: "",
          baseUrl: "",
          token: "",
          sedex: "",
          pac: "",
        },
        updatedAt: "Sem registros"
      },
      dialog: false,
    };
  },
  components: { IntegrationCard }
};
</script>
<style>
.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.integration-image {
  margin: 5px;
  height: 40px;
}

.w-33 {
  width: 33%;
}

.w-50 {
  width: 50%;
}
</style>